import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

if(location.pathname == "/recruit/fresh_career.html") {
  var controller = new ScrollMagic.Controller();

  var scene_lead1 = new ScrollMagic.Scene({
    triggerElement: ".top-lead",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: -50
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators()
  .addTo(controller);

  scene_lead1.on('enter', ()=>{
    var tl = new TimelineMax();
    var $height = $(".top-lead__heading").outerHeight();

    // tl.to(".top-lead__title", 1.2,{ height:$height })

    tl.to(".top-lead__title", 0.8,{ y: "0", alpha: 1, delay: -0.3, onComplete: function(){
      $(".top-lead").addClass("is-current")
    } })
    .to(".top-lead .top-lead__subTitle", 0.8,{ y: "0", alpha: 1, delay: -0.3 })
    .to(".top-lead .top-lead__message", 0.8,{ y: "0", alpha: 1, delay: -0.3 })
    .to(".top-lead .top-lead__text", 0.8,{ y: "0", alpha: 1, delay: -0.6 })

    // console.log(scene_lead1.scrollOffset());
    // console.log(scene_lead1.state());
    // console.log(scene_lead1.triggerPosition());


  });

  var scene_message = new ScrollMagic.Scene({
    triggerElement: ".top-message",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: 80
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators(2)
  .addTo(controller);

  scene_message.on('enter', ()=>{
    var tl = new TimelineMax();
    var $height = $(".top-message").outerHeight();

    // tl.to(".top-lead__title", 1.2,{ height:$height })
    // tl.to(".top-lead__title", 0.8,{ y: "0", alpha: 1, delay: -0.3, onComplete: function(){
    $(".top-message").addClass("is-current")
    // } })
    // tl.to(".top-message .top-message__image").addClass("is-current")
    tl.to(".top-message__title h2", 0.8,{ x: "0", alpha: 1, delay: -0.2 })
    tl.to(".top-message__title .top-message__subTitle", 0.8,{ y: "0", alpha: 1, delay: -0.3 })
    tl.to(".top-message__text", 0.8,{ y: "0", alpha: 1, delay: -0.3 })

    // console.log(scene_message.scrollOffset());
    // console.log(scene_message.state());
    // console.log(scene_message.triggerPosition());


  });

  var scene_information = new ScrollMagic.Scene({
    triggerElement: ".top-information",
    triggerHook: 'onCenter',
    // duration: 100,
    offset: -100
  })
  // .setClassToggle("#aaaa", "is-current")
  // .addIndicators(3)
  .addTo(controller);

  scene_information.on('enter', ()=>{
    var tl = new TimelineMax();
    var $height = $(".top-information").outerHeight();

    // tl.to(".top-lead__title", 1.2,{ height:$height })
    // tl.to(".top-lead__title", 0.8,{ y: "0", alpha: 1, delay: -0.3, onComplete: function(){
    $(".top-information").addClass("is-current")
    // } })
    // tl.to(".top-information .top-information__image").addClass("is-current")
    tl.to(".top-information__title h2", 0.8,{ x: "0", alpha: 1, delay: -0.2 })
    tl.to(".top-information__title .top-information__subTitle", 0.8,{ y: "0", alpha: 1, delay: -0.3 })
    tl.to(".top-information__text", 0.8,{ y: "0", alpha: 1, delay: -0.3 })

    // console.log(scene_message.scrollOffset());
    // console.log(scene_message.state());
    // console.log(scene_message.triggerPosition());


  });
}
